module.exports = __webpack_public_path__ + "static/case_steph-0583a0af45f43cf57b365682ae49f74e.jpg";